export default __webpack_public_path__ + "static/media/image__right.0a1a453b.png";